import React from 'react';
import PropTypes from 'prop-types';
import DrivesListHeader from './DrivesListHeaderComponent';
import DrivesListRow from './DrivesListRowComponent';

const ConnectedAssetsDrivesComponent = ({ gatewayInformation, gatewayConnectedDriveData, assetType, searchQuery, handleShowInfoClick, gatewayID, gatewaySerialNumber, isMoveValid, validationLoadingStatus, isSwitchValid, validateSwitchLoadingStatus, gatewayAssetsList, gatewayAssetsListLoadingStatus, isSwitchEgwToAnotherGateway, switchGatewayId, onResetAssetInfo }) => {
    const showHeader = gatewayConnectedDriveData?.length === 0 ? false : true;
    // Filtered list based on the search query for both name and serialNumber
    const filteredGatewayConnectedDriveData = gatewayConnectedDriveData.filter((asset) => {
        const nameMatches = asset?.name?.toLowerCase().includes(searchQuery?.toLowerCase() || '');
        const serialNumberMatches = asset?.serialNumber?.toLowerCase().includes(searchQuery?.toLowerCase() || '');
        return nameMatches || serialNumberMatches;
    });

    return (
        <div className='drives-list'>
            <div className='drives-list__body'>
                {showHeader && <DrivesListHeader assetType={assetType} gatewayConnectedDriveData={filteredGatewayConnectedDriveData} />}
                <DrivesListRow gatewayInformation={gatewayInformation} gatewayConnectedDriveData={filteredGatewayConnectedDriveData} assetType={assetType} handleShowInfoClick={handleShowInfoClick} gatewayID={gatewayID} gatewaySerialNumber={gatewaySerialNumber} isMoveValid={isMoveValid} validationLoadingStatus={validationLoadingStatus} isSwitchValid={isSwitchValid} validateSwitchLoadingStatus={validateSwitchLoadingStatus} gatewayAssetsList={gatewayAssetsList} gatewayAssetsListLoadingStatus={gatewayAssetsListLoadingStatus} isSwitchEgwToAnotherGateway={isSwitchEgwToAnotherGateway} switchGatewayId={switchGatewayId} onResetAssetInfo={onResetAssetInfo} />
            </div >
        </div >
    );
};

ConnectedAssetsDrivesComponent.propTypes = {
    gatewayInformation: PropTypes.object,
    gatewayConnectedDriveData: PropTypes.array,
    searchQuery: PropTypes.string,
    handleShowInfoClick: PropTypes.func,
    assetType: PropTypes.string,
    gatewayID: PropTypes.number,
    gatewaySerialNumber: PropTypes.string,
    isMoveValid: PropTypes.bool,
    validationLoadingStatus: PropTypes.string,
    onResetAssetInfo: PropTypes.func
};

export default ConnectedAssetsDrivesComponent;
